// extracted by mini-css-extract-plugin
export default {"favouriteStopsContainer":"FavouriteStops_favouriteStopsContainer__uuCNf"};